<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_ic">Contents</a></h1><a id="page_ic">
</a><h2 class="toc-chap"><a id="page_ic"></a><a href="#/xhtml/02_Chapter01">Act I</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/03_Chapter02" title="Link target outside of Sample">Act II</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/04_Chapter03" title="Link target outside of Sample">Act III</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/05_Chapter04" title="Link target outside of Sample">Act IV</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/06_Chapter05" title="Link target outside of Sample">Act V</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?055cc174